import React, { useMemo } from "react";

const decodeEntities = (str) =>
  typeof str === "string"
    ? str.replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&quot;/g, '"')
    : str;

const getColor = (value, min, max) => {
  if (value == null || value === "") return "transparent";
  const range = max - min || 1;
  const ratio = (value - min) / range;
  return `rgba(41, 112, 172, ${0.15 + ratio * 0.85})`;
};

const HeatmapBlock = ({ heatmap }) => {
  const { title, rows = [], columns = [], values = [], value_suffix = "" } = heatmap || {};

  const { min, max } = useMemo(() => {
    let min = Infinity;
    let max = -Infinity;
    values.forEach((row) =>
      row.forEach((v) => {
        if (v != null && v !== "") {
          if (v < min) min = v;
          if (v > max) max = v;
        }
      })
    );
    return { min: min === Infinity ? 0 : min, max: max === -Infinity ? 0 : max };
  }, [values]);

  if (!rows.length || !columns.length || !values.length) return null;

  return (
    <div className="heatmap-block">
      {title && <div className="heatmap-block__title">{decodeEntities(title)}</div>}
      <div className="heatmap-block__scroll">
        <table className="heatmap-block__table">
          <thead>
            <tr>
              <th className="heatmap-block__corner" />
              {columns.map((col, i) => (
                <th key={i} className="heatmap-block__col-header">
                  {col}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, ri) => (
              <tr key={ri}>
                <td className="heatmap-block__row-header">{row}</td>
                {(values[ri] || []).map((val, ci) => (
                  <td
                    key={ci}
                    className="heatmap-block__cell"
                    style={{ backgroundColor: getColor(val, min, max) }}
                  >
                    {val != null && val !== "" ? `${val}${value_suffix}` : ""}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default HeatmapBlock;
